// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Get, Put } from 'config/apiServiceConfig'

export const getTimeslotAvailable = (orderID: any): any =>
  Get({ url: `/api/order/${orderID}/available-change-timeslot` })
export const postSubmitChangeTimeslot = (orderId: any, payload: any): any =>
  Put({ url: `api/order/timeslots/${orderId}`, data: payload })
